import type { RoulettePrizeType } from '@/lib/roulette'

export interface RouletteShareCardCopy {
  badge: string
  title: string
  resultLabel: string
}

export function getRouletteShareCardCopy(prizeType: RoulettePrizeType): RouletteShareCardCopy {
  if (prizeType === 'none') {
    return {
      badge: 'Participante',
      title: 'Não foi desta vez!',
      resultLabel: 'Resultado',
    }
  }

  return {
    badge: 'Ganhador',
    title: 'Parabéns!',
    resultLabel: 'Você ganhou',
  }
}

export function buildRouletteShareFilename(prizeId: number, prizeType: RoulettePrizeType): string {
  const date = new Date().toISOString().slice(0, 10)
  const prefix = prizeType === 'none' ? 'participante-roleta' : 'ganhador-roleta'
  return `${prefix}-${prizeId}-${date}.png`
}

export function getRouletteShareDownloadAriaLabel(
  prizeType: RoulettePrizeType,
  donorName: string | undefined,
  prizeId: number
): string {
  const subject = prizeType === 'none' ? 'participante' : 'ganhador'
  const name = donorName ?? String(prizeId)
  return `Baixar imagem do ${subject} ${name}`
}
